const initialState = {
    userPermissions: [],   
    isReadingRole: false,
    isUpdatingRole: false,
    roleBeingDeleted: null
};

export default initialState;
